module.exports = __webpack_public_path__ + "static/media/SavingsImage@2x.b6317e1d.png";